import { render } from "./ServiceExtracts.vue?vue&type=template&id=44f94bf5"
import script from "./ServiceExtracts.vue?vue&type=script&lang=js"
export * from "./ServiceExtracts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__